import { forwardRef } from "react";
import { useTranslation } from "next-i18next";
import { BaseInputProps } from "@talladega/types";
import { customerValidation } from "@talladega/helpers";
import { getInputStyles, getBaseInputProps } from "../helpers";
import { BaseInput } from "../form";

// eslint-disable-next-line no-underscore-dangle
const _Email = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      type = "email",
      id = "email",
      disabled,
      autoComplete = "email",
      className,
      suppressHotjar = true,
      fieldError,
      onKeyDown,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation("common");
    const getFeedback = () => {
      if (!fieldError?.message) {
        if (fieldError?.type === "required") {
          return t("required");
        }
        if (fieldError?.type === "pattern") {
          return t("invalid_email");
        }
      }
      return fieldError?.message;
    };
    const baseInputProps = getBaseInputProps({
      type,
      disabled,
      label: props.label || t("email") || undefined,
      status: fieldError ? "error" : "default",
      feedback: getFeedback(),
      ...props,
    });
    const inputClassName = getInputStyles({
      leftIcon: baseInputProps.leftIcon,
      rightIcon: baseInputProps.rightIcon,
      border: baseInputProps.border,
      placeholderSize: baseInputProps.placeholderSize,
      status: baseInputProps.status,
    });
    return (
      <BaseInput id={id} className={className} {...baseInputProps}>
        <input
          id={id}
          className={inputClassName}
          type={type}
          autoComplete={autoComplete}
          maxLength={customerValidation.email.maxLength}
          label={baseInputProps.label}
          disabled={disabled}
          ref={ref}
          data-hj-allow={(!suppressHotjar && type === "text") || undefined}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
            if (onKeyDown) onKeyDown(e);
          }}
          {...props}
        />
      </BaseInput>
    );
  }
);

export default _Email;
